import { NOTIFICATIONS_NEW_NOTIFICATION } from '../actions';
import { NAVBAR_NOTIFICATIONS_BADGE } from '../../constants/actions';
import * as selectors from '../selectors';

const onNewNotification = ({ displayNotification }) => (notification) => (
  dispatch,
  getState
) => {
  const state = getState();
  const alreadyExists = selectors.lastNotificationId(state) === notification.id;

  if (alreadyExists) {
    return;
  }

  dispatch({
    type: NOTIFICATIONS_NEW_NOTIFICATION,
    status: 'success',
    payload: { notification },
  });

  if (
    ['newPost', 'newComment', 'newCommentReply'].includes(
      notification.notification.action
    )
  ) {
    dispatch({
      type: NAVBAR_NOTIFICATIONS_BADGE,
      hasUnread: true,
    });
  }

  displayNotification({
    notification,
    getState,
    selectors,
  });
};

export default onNewNotification;
